import { defineComponent as _defineComponent } from 'vue'
import VFooter from "@/components/vFooter.vue";
import DirectSignupForm from "@/components/forms/Signup/DirectSignupForm.vue";
import {useTranslations} from "@/hooks/useTranslations";
import {useRoute} from "vue-router/composables";
import {MarketingParams} from "@/models/Subscriptions/MarketingParams";
import {onMounted, ref} from "vue";
import SubscriptionRepository from "@/utils/API/SubscriptionRepository";
import Package from "@/models/Subscriptions/SubscriptionPackages/Package";
import {useStore} from "@/hooks/useStore";
import {TRANSLATIONS_FETCH} from "@/store/ActionTypes";
import DirectSignUpVerificationForm from "@/components/forms/Signup/DirectSignUpVerificationForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DirectSignup',
  setup(__props) {

const translations = useTranslations();
const route = useRoute();
const store = useStore();
const isVerificationMode = ref(false);
const verificationEmail = ref("");

const marketingParams = ref<MarketingParams>({
  source: '',
  medium: '',
  campaign: '',
  term: '',
  gclid: '',
});
const selectedPackage = ref<string>();
const recurrence = ref<string>();
const shouldDisplayNutrientSources = ref<boolean>(false);

onMounted(async() =>{
  await getPackageInfo();
  await store.value.dispatch(TRANSLATIONS_FETCH, {
    category: "pages",
    collections: [
      "common",
      "login",
      "customers",
      "managesubscription",
      "profile",
    ],
  });
});

async function getPackageInfo() {
  const query = route.query;

  marketingParams.value.source = (query.utm_source as string) || '';
  marketingParams.value.medium = (query.utm_medium as string) || '';
  marketingParams.value.campaign = (query.utm_campaign as string) || '';
  marketingParams.value.term = (query.utm_term as string) || '';
  marketingParams.value.gclid = (query.gclid as string) || '';

  // Check the route's params for a package
  selectedPackage.value = query.package as string;
  // Check the route's params for a recurrence
  recurrence.value = query.freq as string;

  // If the url has a package and recurrence, then the packages are fetched accordingly.
  if (selectedPackage.value && recurrence.value) {
    const response = await SubscriptionRepository.getByFriendlyName(selectedPackage.value, recurrence.value);
    const packages: Package[] = response.data;

    packages.forEach((pkg) => {
      shouldDisplayNutrientSources.value = pkg.availableNutrientSources.length <= 2;
    });
  }
}

function handleSignupSuccess(email: string) {
  verificationEmail.value = email;
  isVerificationMode.value = true;
}

function handleVerifiedFailure(msg: string) {
  console.error(msg);
}


return { __sfc: true,translations, route, store, isVerificationMode, verificationEmail, marketingParams, selectedPackage, recurrence, shouldDisplayNutrientSources, getPackageInfo, handleSignupSuccess, handleVerifiedFailure, VFooter, DirectSignupForm, DirectSignUpVerificationForm }
}

})